// Copyright (c) 2016 Deere & Company

import PrimaryLangauage, {getDefaultState as getPrimaryLanguageDefaultState} from './primary-language';
import t from 'tcomb';

const LanguageSettings = t.struct({
    primaryLanguage: PrimaryLangauage
}, {
    name: 'LanguageSettings',
    strict: true
});

export const getDefaultState = () => new LanguageSettings({
    primaryLanguage: getPrimaryLanguageDefaultState()
});

export default LanguageSettings;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/language-settings.js